(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_groups/banner-columns/assets/javascripts/render-component.js') >= 0) return;  svs.modules.push('/components/banner_groups/banner-columns/assets/javascripts/render-component.js');

'use strict';

function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function (r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function () { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function (r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function (r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
const isServer = typeof exports === 'object';
let logger;
if (isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  logger = trinidad.logger('banner-groups: banner-columns');
} else {
  logger = svs.core.log.getLogger('banner-groups: banner-columns');
}
const getBannerComponent = (data, layout) => {
  if (isServer) {
    return data.components["banner_layouts/".concat(layout)];
  }
  return svs.banner_layouts[layout.replace(/-/g, '_')];
};

async function renderComponent(data, widgetInfo, req, res) {
  let hbsTemplateCompiled;
  if (isServer) {
    const hbs = global.internalInstances.get('hbs');
    hbsTemplateCompiled = hbs.cache['components-banner_groups-banner_columns-banner_columns'];
  } else {
    hbsTemplateCompiled = svs.banner_groups.banner_columns.templates.banner_columns;
  }
  let i = 0;
  const childElements = [];
  logger.info("Preparing ".concat(data.banners.length, " ").concat(widgetInfo.widgetType, " banners."));
  var _iteratorAbruptCompletion = false;
  var _didIteratorError = false;
  var _iteratorError;
  try {
    for (var _iterator = _asyncIterator(data.banners), _step; _iteratorAbruptCompletion = !(_step = await _iterator.next()).done; _iteratorAbruptCompletion = false) {
      const banner = _step.value;
      {
        i++;
        if (!banner.layoutType) {
          logger.warn("Banner id ".concat(banner.id, " lacks layoutType property"));
          continue;
        }
        const bannerComponent = getBannerComponent(data, banner.layoutType);
        const allowedColumns = banner.layoutConfig.allowedColumns !== undefined ? banner.layoutConfig.allowedColumns[0] : 3;
        let columnWrapper;
        if (allowedColumns === 2) {
          columnWrapper = 'grid-flex-col-xs-12 grid-flex-col-am-6';
        } else {
          columnWrapper = 'grid-flex-col-xs-12 grid-flex-col-am-6 grid-flex-col-md-4';
        }
        try {
          const bannerHtml = await bannerComponent.renderComponent(banner, widgetInfo, i, req, res);
          childElements.push({
            html: bannerHtml,
            columnWrapper
          });
        } catch (error) {
          logger.warn("Banner skipped due to banner loading error: ".concat(error.toString()), req);
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (_iteratorAbruptCompletion && _iterator.return != null) {
        await _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  logger.info("Rendering ".concat(childElements.length, " ").concat(widgetInfo.widgetType, " banners for widget ").concat(data.config.widgetId, "."));
  const model = {
    title: data.config.title,
    widgetId: data.config.widgetId,
    subTitle: data.config.subTitle,
    childElements,
    readMore: data.config.readMore,
    gridClasses: 'banner-group-columns',
    childElementsCount: childElements.length
  };
  return hbsTemplateCompiled(model) || '';
}
if (isServer) {
  module.exports = {
    renderComponent
  };
} else {
  svs.banner_groups.banner_columns = {
    renderComponent
  };
}

 })(window);